<template>
    <a-modal title="编辑评论内容" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel"
        destroyOnClose :maskClosable="false" width="800px">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item label="项目名称" prop="project_name">
                <a-tag>{{ form.project_name }}</a-tag>
            </a-form-model-item>
            <a-form-model-item label="评价内容" prop="department_name">
                <a-textarea v-model="form.commit" placeholder="评论内容" :auto-size="{ minRows: 2 }" />
            </a-form-model-item>
            <a-form-model-item label="评价图片" prop="imgs">
                <MyUpload v-model="form.imgs"></MyUpload>
            </a-form-model-item>
            <a-form-model-item label="评分" prop="rate">
                <a-rate v-model="form.rate"></a-rate>
            </a-form-model-item>
            <a-form-model-item label="评价时间" prop="commit_time">
                <a-date-picker v-model="form.commit_time" show-time />
            </a-form-model-item>
            <a-form-model-item label="是否匿名" prop="anonymous">
                <a-radio-group v-model="form.anonymous">
                    <a-radio value="1">是</a-radio>
                    <a-radio value="2">否</a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="是否对外可见" prop="commit_show" required>
                <a-radio-group v-model="form.commit_show">
                    <a-radio value="1">是</a-radio>
                    <a-radio value="2">否</a-radio>
                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
import { baseURL } from "@/api/index";
import { mapState } from "vuex";
import MyUpload from "@/components/MyUpload/index.vue";
export default {
    components: {
        MyUpload,
    },
    data() {
        return {
            baseURL,
            visible: false,
            confirmLoading: false,
            form: {
                tripproject_id: undefined,
                project_name: '',
                commit: '',
                rate: 0,
                imgs: [],
                anonymous: '1',
                commit_show: '1',
                commit_time: undefined,
            },
            groupList: [],
            loadingGroup: false,
            rules: {

            },
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
    },
    computed: {
        ...mapState(["token"]),
    },
    methods: {
        init(id) {
            this.visible = true;
            this.form.tripproject_id = id;
            if (id) {
                this.$http({
                    url: "/admin/tripproject/info",
                    method: "post",
                    data: {
                        id
                    },
                }).then((res) => {
                    this.form.project_name = res.data.project_name;
                    this.form.commit = res.data.commit;
                    this.form.rate = res.data.rate;
                    this.form.imgs = res.data.imgs ? res.data.imgs.split(",") : [];
                    this.form.anonymous = res.data.anonymous;
                    this.form.commit_show = res.data.commit_show;
                    this.form.commit_time = res.data.commit_time;
                });
            }
        },
        preview(e) {
            this.$viewerApi({
                images: [e.response.url],
            });
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    console.log(this.form);
                    this.confirmLoading = true;
                    this.$http({
                        url: '/admin/tripproject/commitupdate',
                        method: "post",
                        data: {
                            ...this.form,
                            imgs: this.form.imgs.join(","),
                        },
                    })
                        .then(() => {
                            this.$message.success(
                                this.form.department_id ? "修改成功" : "创建成功"
                            );
                            this.handleCancel();
                            this.$emit("ok");
                        })
                        .catch(() => {
                            this.confirmLoading = false;
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleCancel() {
            this.visible = false;
            this.confirmLoading = false;
            this.$refs["ruleForm"].resetFields();
        },
    },
};
</script>

<style></style>